import type { McpToolsSellAllOutputSkippedItem } from "../api/models/mcpToolsSellAllOutputSkippedItem";

/** Uma moeda que ficou fora do `sell_all`, com o porquê já em texto. */
export type SellAllSkip = {
  coin: string;
  reason: string;
};

function formatAmount(value: string): string {
  const n = Number(value);

  return Number.isFinite(n)
    ? n.toLocaleString("pt-BR", { maximumFractionDigits: 8 })
    : value;
}

function skipReason(item: McpToolsSellAllOutputSkippedItem): string {
  switch (item.reason) {
    case "below_minimum":
      // Nem chegou a ser cotada: o valor não alcança o mínimo da exchange.
      return item.minimum
        ? `Abaixo do mínimo de venda (mín. ${formatAmount(item.minimum)} ${item.coin})`
        : "Abaixo do mínimo de venda";
    case "no_available_balance":
      return "Sem saldo disponível";
    default:
      return item.error?.message || "Sem cotação";
  }
}

/**
 * `skipped` do `sell_all` (args do card ou resultado da tool) → uma linha por
 * moeda que ficou fora da venda.
 */
export function getSellAllSkips(skipped: unknown): SellAllSkip[] {
  if (!Array.isArray(skipped)) return [];

  return skipped
    .filter((item): item is McpToolsSellAllOutputSkippedItem =>
      Boolean(item) && typeof item === "object" &&
      typeof (item as { coin?: unknown }).coin === "string"
    )
    .map((item) => ({ coin: item.coin, reason: skipReason(item) }));
}
